export type {
  PlatformGlobals,
  PlatformGlobalsFactory,
} from "./PlatformGlobals.js";
export { InMemoryPlatformGlobalsFactory } from "./in-memory.js";
export { BrowserPlatformGlobalsFactory } from "./browser.js";

import { BrowserPlatformGlobalsFactory } from "./browser.js";
import { InMemoryPlatformGlobalsFactory } from "./in-memory.js";
import type {
  PlatformGlobals,
  PlatformGlobalsFactory,
} from "./PlatformGlobals.js";

/**
 * Environment-aware factory selector. Returns the browser factory
 * when `window` is available, or the in-memory factory otherwise.
 * Consumers call this once at component construction; tests pass a
 * stub directly.
 */
export const defaultPlatformGlobalsFactory = (): PlatformGlobalsFactory => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return new InMemoryPlatformGlobalsFactory();
  }
  return new BrowserPlatformGlobalsFactory();
};

/**
 * Convenience: build a `PlatformGlobals` instance with the default
 * factory. The Reports routes call this once at the top of the
 * component; tests pass `{ factory }` to use a recording stub.
 */
export const buildPlatformGlobals = (
  input: { readonly trpc: unknown; readonly factory?: PlatformGlobalsFactory },
): PlatformGlobals => {
  const factory = input.factory ?? defaultPlatformGlobalsFactory();
  return factory.build({ trpc: input.trpc });
};
